import { Helmet } from 'react-helmet';
import { Box, Heading, Text, Image } from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { getBlog, extractImageFromContent, getHTMLContent } from '../utilities/blogUtils';

function NewsPage() {
  const location = useLocation();
  const { postId } = useParams();

  const [blog, setBlog] = useState(location.state || null);
  const [loading, setLoading] = useState(!location.state);

  useEffect(() => {
    if (!location.state) {
      getBlog(postId, setBlog, setLoading);
    }
  }, [postId]);

  if (loading) {
    return (
      <Box mx='auto' maxW='1200px' color='white' px={{ base: 4, md: 8 }} py={8}>
        <Text textAlign="center" py={16}>Loading...</Text>
      </Box>
    );
  }

  if (!blog) {
    return (
      <Box mx='auto' maxW='1200px' color='white' px={{ base: 4, md: 8 }} py={8}>
        <Heading textAlign="center" py={16}>Post Not Found</Heading>
        <Box mb={12}>
          <Text
            as='a'
            href='/news'
            cursor="pointer"
            fontSize='lg'
            color='white'
            fontWeight='semibold'
            _hover={{ color: 'primary' }}
          >
            ← Back to News
          </Text>
        </Box>
      </Box>
    );
  }

  return (
    <>
      <Helmet>
        <title>{blog.title} | Leaderbored News</title>
      </Helmet>
      <Box mx='auto' maxW='1200px' color='primary'>

        {/* Back Button */}
        <Box mb={12}>
          <Text
            as='a'
            href='/news'
            cursor="pointer"
            fontSize='lg'
            color='black'
            fontWeight='semibold'
            _hover={{ color: 'primary' }}
          >
            ← Back to News
          </Text>
        </Box>
        {/* rgb(30, 30, 30); */}
        <Box bgColor='rgba(102,153,204,0)' px={{ base: 4, md: 8 }} py={8}>

          <Box>
            {extractImageFromContent(blog.content) && (
              <Box mb={2}> {/* IMAGE TO TITLE SPACING */}
                <Image
                  src={extractImageFromContent(blog.content)}
                  alt={blog.title}
                  width='100%'
                  maxH='600px'
                  objectFit='cover'
                  borderRadius='16px'
                />
              </Box>
            )}
            {/* TITLE */}
            <Box
              mb={6}
              paddingX={3}
              paddingY={4}
              color='white'
              bg={"rgba(28, 85, 150, 1)"}
              borderRadius='16px'
              > 
              <Heading
                fontSize={{ base: '4xl', md: '6xl' }}
              >
                {blog.title}
              </Heading>
            </Box>
            <Box
              flexWrap='wrap'
              fontSize='md'
              color='blackAlpha.600'
              pb={0}
              mb={-2}
              borderBottom='1px solid'
              borderColor='blackAlpha.200'
            >
              <Box display='flex' gap={3} mb={4}>
                <Text>{'By '}
                  <Text as='span' color='black' fontWeight='semibold'>
                    {blog.author.displayName}
                  </Text>
                </Text>
                <Text>•</Text>
                <Text>
                  {new Date(blog.published).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </Text>
              </Box>

              
            </Box>
            
            {/* ARTICLE TEXT */}
            <Box /* bgColor='black' */ p={6} marginBottom={12}>
              <Box
                fontSize='xl'
                lineHeight='tall'
                whiteSpace='pre-wrap'
                color='blackAlpha.900'
                dangerouslySetInnerHTML={{ __html: getHTMLContent(blog.content) }}
                sx={{
                    'a': { color: 'yellow.300', textDecoration: 'underline' },
                }}
              >
              </Box>
            </Box>
            <Box
              display='flex'
              justifyContent='center'
            >   

            {/* LABEL BADGES */}
            {blog.labels && blog.labels.length > 0 && (
                <Box display='flex' gap={2} flexWrap='wrap'>
                  {blog.labels.map((label, index) => (
                    <Box
                      key={index}
                      px={3}
                      py={1}
                      bgColor='primary'
                      color='white'
                      fontSize='sm'
                      fontWeight='semibold'
                      borderRadius='full'
                    >
                      {label}
                    </Box>
                  ))}
                </Box>
              )}
            </Box> 
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default NewsPage;
